import styled from "@emotion/styled";

import { BREAKPOINTS, MOBILE_MAX_WIDTH, media } from "../constants";
import { Div } from "./layout";

export const ModalOverlay = styled.div`
  label: modal-overlay;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  align-items: ${(props) => props.alignItems || "flex-start"};
  justify-content: center;
  padding: ${(props) => props.padding || "30px 0"};
  overflow-y: auto;

  ${media.min(BREAKPOINTS.desktopMin)} {
    overflow-y: auto;
    padding: ${(props) => props.padding || "50px"};
    align-items: center;
  }

  ${media.max(BREAKPOINTS.tabletMin)} {
    z-index: 999;
  }
`;

export const ModalWrapper = styled.div`
  label: modal-wrapper;
  position: relative;
  z-index: 1000;
  width: 100%;
  max-width: 400px;
  margin: 0 20px;
`;

export const ModalContent = styled.div`
  label: modal-content;
  background: ${({ theme }) => theme.custom.white};
  width: ${(props) => props.width || ""};
  border-radius: 20px;
  padding: 30px 20px 20px;
  position: relative;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 180px;
  z-index: 1001;

  ${media.max(MOBILE_MAX_WIDTH)} {
    padding: 20px 15px;
  }
`;

export const ModalEventContent = styled.div`
  label: modal-event-content;
  background: ${({ theme }) => theme.custom.white};
  position: absolute;
  z-index: 100;
  width: 300px;
  height: auto;
  right: -340px;
  top: 0;
  border-radius: 20px;
  padding: 30px;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  min-height: 180px;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
`;

export const AccordionEventContent = styled.div`
  label: accordion-event-content;
  width: 100%;
  background: ${({ theme }) => theme.custom.white};
  border-radius: 12px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
`;

export const ModalAddEvent = styled(ModalContent)`
  gap: 0;
  padding: 0;
`;

export const MobileModalContent = styled(Div)`
  label: mobile-modal-event-content;
  position: relative;
  width: 100%;
  max-width: 560px;
  padding: 20px;
  border-radius: 20px;
  background: ${({ theme }) => theme.custom.white};
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
`;


